import toISOStringWithTimezone from '../../shared/utils/toISOStringWithTimezone';

interface DateParamProps {
  reportType: string;
  type: string;
  startDate: Date;
  endDate: Date;
}

const dateParam = ({
  reportType,
  type,
  startDate,
  endDate,
}: DateParamProps) => {
  const today = new Date();
  let startDateParam: string = '';
  let endDateParam: string = '';

  if (reportType === 'Previous Month') {
    // get first day date of previous month
    startDateParam = toISOStringWithTimezone(
      new Date(today.getFullYear(), today.getMonth() - 1, 1),
      'start',
    );
    // get last day date of previous month
    endDateParam = toISOStringWithTimezone(
      new Date(today.getFullYear(), today.getMonth(), 0),
      'end',
    );
  }

  if (reportType === 'This Month') {
    // get first day date of current month
    startDateParam = toISOStringWithTimezone(
      new Date(today.getFullYear(), today.getMonth(), 1),
      'start',
    );
    // get last day date of current month
    endDateParam = toISOStringWithTimezone(
      new Date(today.getFullYear(), today.getMonth() + 1, 0),
      'end',
    );
  }

  // custom date range
  if (reportType.includes('Custom Date Range') && startDate && endDate) {
    startDateParam = toISOStringWithTimezone(startDate, 'start');
    endDateParam = toISOStringWithTimezone(endDate, 'end');
  }

  return type === 'start' ? startDateParam : endDateParam;
};

export default dateParam;
